const api = {
    hqyzmkey: '/login/hqyzmkey', //获取图片验证码
    createtpyzm: '/login/createtpyzm', //获取图片验证码
    dologin: '/login/dologin',  //后台登录

    tianjiachengshi: '/houtai/tianjiachengshi',  //添加城市
    ckszdqmrhh: '/houtai/ckszdqmrhh',  //城市列表
    editchengshi: '/houtai/editchengshi',  //编辑城市
    delchengshi: '/houtai/delchengshi',  //删除城市

    addbisaixm: '/houtai/addbisaixm',  //添加类型和项目
    saishilxlist: '/houtai/saishilxlist',  //类型列表
    saishixmary: '/houtai/saishixmary',  //项目列表
    editssxiangmu: '/houtai/editssxiangmu',  //类型和项目修改
    delssxiangmu: '/houtai/delssxiangmu',  //类型和项目删除

    addbisai: '/houtai/addbisai',  //创建赛事
    getallbisaixmary: '/houtai/getallbisaixmary',  //获取赛事类型
    bisailist: '/houtai/bisailist',  //赛事列表
    getsaishiinfo: '/houtai/getsaishiinfo',  //赛事详情
    editsaishi: '/houtai/editsaishi',  //修改赛事
    delbisai: '/houtai/delbisai',  //删除赛事

    addbaomingset: '/houtai/addbaomingset',  //创建报名设置
    bmszlist: '/houtai/bmszlist',  //创建报名列表
    bmszinfo: '/houtai/bmszinfo',  //报名详情
    editbmsz: '/houtai/editbmsz',  //修改报名详情
    tingyongbmsz: '/houtai/tingyongbmsz',  //启用/停用报名设置 1启用 2停用
    bmbiaodanyuansust: '/houtai/bmbiaodanyuansust',  //报名设置字段
    bmbdysstinfo: '/houtai/bmbdysstinfo',  //获取报名字段展示
    editbmbdysst: '/houtai/editbmbdysst',  //修改报名字段
    chuangjianzbyqm: '/forluoji/chuangjianzbyqm',  //创建邀请码
    zbyqmlist: '/forluoji/zbyqmlist',  //邀请码列表
    delzbyqm: '/forluoji/delzbyqm',  //删除邀请码
    genggaibmxinxi: '/houtai/genggaibmxinxi',  //修改报名人员信息
    dcyqmlbexcel: '/forluoji/dcyqmlbexcel',  //邀请码导出


    addlunbotu: '/houtai/addlunbotu',  //添加轮播图
    lunbotulist: '/houtai/lunbotulist',  //轮播图列表
    editlunbotu: '/houtai/editlunbotu',  //轮播图修改
    delunbotu: '/houtai/delunbotu',  //轮播图删除

    chuangjianpaotuan: '/houtai/chuangjianpaotuan',  //创建跑团
    paotuanlist: '/houtai/paotuanlist',  //跑团列表
    editpaotuan: '/houtai/editpaotuan',  //跑团编辑
    delpaotuan: '/houtai/delpaotuan',  //跑团删除
    saishitbptfxsz: '/houtai/saishitbptfxsz',  //赛事跑团设置分享不可看和可看
   
    getallpaotuanary: '/houtai/getallpaotuanary',  //跑团下拉列表接口
    saishiaddtbpt: '/houtai/saishiaddtbpt',  //添加团报
    sstbpaotuanlist: '/houtai/sstbpaotuanlist',  //团报列表
    saishisctbpt: '/houtai/saishisctbpt',  //删除团报
    addtuanbaoyqm: '/houtai/addtuanbaoyqm',  //新增团报邀请码
    tbyqmlist: '/houtai/tbyqmlist',  //邀请码列表
    deltbyqm: '/houtai/deltbyqm',  //邀请码删除

    baomingjllist: '/houtai/baomingjllist',  //报名列表
    saishizbary: '/houtai/saishizbary',  //报名列表 组别列表获取
    daochubmjlexcel: '/houtai/daochubmjlexcel',  //excel导出
    shenhebmjlsq: '/houtai/shenhebmjlsq',  //报名审核
    glytuikuan: '/houtai/glytuikuan',  //报名退款
    delbaomingjilu: '/houtai/delbaomingjilu',  //报名删除

    chakanbmcys: '/houtai/chakanbmcys',  //团体详情

    tuikuansqlist: '/houtai/tuikuansqlist',  //退款申请列表
    shenhetksq: '/houtai/shenhetksq',  //审核退款
    deltuikuansq: '/houtai/deltuikuansq',  //删除订单

    daoruexcelbaoming: '/houtai/daoruexcelbaoming',  //报名导入
    saishitbptary: '/houtai/saishitbptary',  //团报列表

    getjibensetinfo: '/houtai/getjibensetinfo',  //获取基本设置
    addjibensz: '/houtai/addjibensz',  //修改基本设置
}


export default api